import {useEffect, useState} from 'react';

import {useSelector} from 'react-redux';

export const DEFAULT_MESSAGE = {
  cat: {
    body: 'Your district has tagged this content with an advisory label. Its use in the classroom may be in violation of district policies or curricular goals. Please contact your administrator for more information.',
    title: 'Important Message',
    hyperlink: null
  }
};

export const EMPTY_MESSAGE = {
  cat: {
    body: '',
    title: '',
    hyperlink: null
  }
};

export const CUSTOM_MESSAGE = {
  cat: {
    body: '',
    title: 'A message from your district',
    hyperlink: {
      text: 'Learn more',
      url: ''
    }
  }
};

/**
 * This function was extracted from the hook to be able to validate the business logic
 * in unit tests.
 *
 * It is not expected to use this function outside this scope.
 * */
export const _determineAdvisoryMessage = ({response, customAdvisoryMessage}) => {
  if (response.ok && !customAdvisoryMessage.date_archived) {
    return {
      cat: {
        body: customAdvisoryMessage.text,
        title: CUSTOM_MESSAGE.cat.title,
        hyperlink: {
          url: customAdvisoryMessage.url,
          text: CUSTOM_MESSAGE.cat.hyperlink.text
        }
      }
    };
  } else {
    return DEFAULT_MESSAGE;
  }
};

export const getContentAdvisoryMessage = async(user) => {
  const isAuthorizedDistrictLeader = user?.district_leader?.date_accepted_terms_and_conditions;
  const district = isAuthorizedDistrictLeader ? user?.district_leader?.district : user?.schools[0].districts[0];

  try {
    const response = await fetch(`/api/v2/district/${district.unique_id}/content-advisory-configuration`);
    const customAdvisoryMessage = await response.json();
    return _determineAdvisoryMessage({response, customAdvisoryMessage});
  } catch (e) {
    return DEFAULT_MESSAGE;
  }
};

export const useContentAdvisoryMessage = () => {
  const user = useSelector(({user}) => user);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [advisoryMessage, setAdvisoryMessage] = useState(EMPTY_MESSAGE);
  useEffect(() => {
    const load = async() => {
      try {
        setLoading(true);
        const cat = await getContentAdvisoryMessage(user);
        setAdvisoryMessage(cat);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);
  return {
    data: advisoryMessage.cat,
    error,
    loading
  };
};
